import { render, staticRenderFns } from "./Detentions.vue?vue&type=template&id=24fc66a2&"
import script from "./Detentions.vue?vue&type=script&lang=js&"
export * from "./Detentions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports